import { render, staticRenderFns } from "./SettingsInform.vue?vue&type=template&id=3133ac1c&scoped=true&"
import script from "./SettingsInform.vue?vue&type=script&lang=js&"
export * from "./SettingsInform.vue?vue&type=script&lang=js&"
import style0 from "./SettingsInform.vue?vue&type=style&index=0&id=3133ac1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133ac1c",
  null
  
)

export default component.exports